import React, { useState, useEffect, useMemo, useRef } from "react";
import queryString from "query-string";
import { useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PageHeaderV2 } from "components/PageHeader";
import { WithTransparentSpinner } from "components/Hoc/WithTransparentSpinner";
import { CheckoutPaymentMethodN } from "components/checkout";
import * as CommonUI from "components";
import useDineInSuccesOrder from "modules/dine-in/useSuccesOrder";
import useSuccesOrder from "features/hooks/useSuccesOrder";
import usePlaceOrderHelper from "features/payment-helpers/usePlaceOrderHelper";
import { PaymentMethodAction } from "store/actions";
import C from "Constants";
import AFS_API from "./afs.api";
import {getPaymentLinkRedirectionObj} from "utils/Utils";


const AfsPaymentConfirmation = ({paymentLinkInfo ={}} = {},
  fetchPaymentLinkInfo = () => {}
) => {
  const location = useLocation();
  const params = useParams();

  const queryParams = queryString.parse(location.search);

  const dispatch = useDispatch();

  const { selectedPaymentType } = useSelector((state) => state.PaymentMethodReducer);

  const { selectedStore } = useSelector((state) => state.store);
  const { orderType, DomainType } = useSelector((state) => state.AppReducer);
  const {checkoutLoader} = useSelector((state) => state.loader);
  const { error, errorModaL: reduxErrorModal } = useSelector((rstate) => rstate.errorSlice);

  const isDineIn =
    orderType?.serviceType === C.SERVICE_TYPE.DINE_IN ||
    window?.location?.pathname?.includes("/dine-in");

  const handleDineInSuccessOrderRoute = useDineInSuccesOrder();
  const handleSuccessOrderRoute = useSuccesOrder();

  const { outlet_based_place_order, brand_based_place_order } =
    usePlaceOrderHelper(
      isDineIn ? handleDineInSuccessOrderRoute : handleSuccessOrderRoute
    );

  // const [paymentStatus, setPaymentStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorModal, setErrorModal] = useState({
    open: false,
    error: null,
  });
  const isMountedRef = useRef(true);

  const paymentLinkRedirectionObj = useMemo(() => {
    if(!paymentLinkInfo?.amount){
      return "/";
    }
    const obj = {
      token:null,
      cartId: paymentLinkInfo?.cartId,
      brandId: paymentLinkInfo?.brandId || selectedStore?.brandId,
      DomainType: DomainType,
      domainName: params?.domainName,
    }
    return getPaymentLinkRedirectionObj(obj);
  }, [paymentLinkInfo]);


  const handleError = () => {
    
    // const params = new URLSearchParams(window.location.search);
    // params.delete("checkoutId");
    // params.delete("resourcePath");
    // params.delete("id");
    // setErrorModal({
    //   open: false,
    //   error: null,
    // });
    // window.location.search = params.toString();
    // window.location.reload();
    if(paymentLinkInfo?.amount){
      const path = paymentLinkRedirectionObj.failureUrl.replace("paymentStatus=failure", "afsPaymentError=afs-error");
      window.location.replace(path);
    }else{
      window.history.go(-1);
    }
  };

  const preparePaymentIntent = async (rawResponse) => {
    let paymentIntent = {};
    paymentIntent.card = rawResponse?.card;
    paymentIntent.ipAddress = rawResponse?.customer?.ip;
    paymentIntent.paymentId = rawResponse?.id;
    paymentIntent.checkoutId = queryParams.checkoutId;
    paymentIntent.ndc = rawResponse?.ndc;
    paymentIntent.brand = rawResponse?.paymentBrand;
    paymentIntent.paymentProvider = C.AFS_PAYMENT;
    paymentIntent.isAfsDev = process.env.REACT_APP_AFS_ENV === "aslase-dev";

    if(rawResponse?.paymentCheckoutIntent){
      const { result, integrity, ...rest } = rawResponse?.paymentCheckoutIntent;
      paymentIntent.paymentCheckoutIntent = rest;
    }
    return paymentIntent;
  };

  const checkAFSPaymentStatus = async () => {
    try {
      const payload = {
        storeId: selectedStore?._id,
        brandId: selectedStore?.brandId,
        checkoutId: queryParams.checkoutId,
      };

      const signedPayload = await btoa(JSON.stringify(payload));
      const response = await AFS_API.checkAFSPaymentStatus({
        signedUrl: signedPayload,
      })
      
      if (!isMountedRef.current) return;

      // setErrorModal({ 
      //   open: true,
      //   error: JSON.stringify(response?.data),
      // });

      if(!selectedPaymentType){
        dispatch(PaymentMethodAction.setSelectedPaymentType(C.AFS_PAYMENT));
      }
      if(!paymentLinkInfo?.amount){
        const paymentIntent = await preparePaymentIntent(response?.data);
        outlet_based_place_order({ paymentIntent })
      } else if(paymentLinkInfo?.amount) {
        await AFS_API.updatePaymentLinkInfo({
          cartId: paymentLinkInfo?.cartId,
          brandId: paymentLinkInfo?.brandId,
          paymentStatus: C.PAYMENT_LINKS.VERIFIED,
          paymentGateway: C.AFS_PAYMENT,
          linkStatus: C.PAYMENT_LINKS.PAID,
          transactionDetail: response?.data,
          paymentId: response?.data?.id,
        });
        window.location.replace(paymentLinkRedirectionObj.successUrl);
      };
    } catch (error) {
      if (isMountedRef.current) {
        setErrorModal({
          open: true,
          error: error?.message || "Something went wrong. Please try again later.",
        });
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
        sessionStorage.removeItem("AFS_PAYMENT",)
      }
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    if (queryParams?.checkoutId) {
      checkAFSPaymentStatus();
    }
    
    return () => {
      isMountedRef.current = false;
    };
  }, [queryParams.checkoutId]);

  useEffect(() => {
    if (reduxErrorModal) {
      setErrorModal({
        open: reduxErrorModal,
        error: error,
      });
    }
  }, [reduxErrorModal]);

  return (
    <>
      <WithTransparentSpinner loading={isLoading || checkoutLoader} />
      <div className="checkout-page min-h-app-height store-page-popup">
       {paymentLinkInfo?.amount ? null: 
       <>
       <PageHeaderV2
          pageTitle={"Payment Confirmation"}
          authClick={() => {}}
          userClick={() => {}}
          containerStyleProps={{
            style: {
              position: "sticky",
              zIndex: 5,
              top: 0,
              backgroundColor: "white",
              width: "98.9%",
              margin: "0 auto",
            },
          }}
          headerStyleProps={{
            className: "p-4",
          }}
        />
        <div className="p-4">
          <CheckoutPaymentMethodN
            key={C.PAY_NOW}
            paymentOptions={
              selectedStore?.paymentOptions ||
              selectedStore?.pickupPaymentOptions ||
              selectedStore?.dineInPaymentOptions
            }
            handleSuceessOrderRoute={() => {}}
            setcardProcessing={() => {}}
            isPaymentConfirmationPage={true}
          />
        </div>
        </>}
      </div>
      <CommonUI.CustomModal
        open={errorModal?.open}
        reduxAction={handleError}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
      >
        <CommonUI.ErrorModal
          reduxAction={handleError}
          message={errorModal?.error}
        />
      </CommonUI.CustomModal>
    </>
  );
};

export default AfsPaymentConfirmation;
